import React from 'react';
import { FormattedMessage } from 'react-intl';

import { fetchAudits } from 'modules/audits/actions/dashboard';
import { openImportBodyScans } from 'modules/bodyScan/actions';
import {
  openImportAudits,
  openImportTScans,
  openImportWorksModal
} from 'modules/interventions/actions/details';
import { openImportTireQuotes } from 'modules/tireQuote/actions';

export const DROPDOWN_META_SOURCE = 'inspection-item';

export const INSPECTION_SECTION_SOURCE = 'intervention-details-inspections';

/** Number of inspections to display per page */
export const INSPECTIONS_PER_PAGE = 10;

export const INSPECTION_TYPE_ENUM = {
  AUDIT: 'AUDIT',
  EXTERNAL_AUDIT: 'EXTERNAL_AUDIT',
  BODY_SCAN: 'BODY_SCAN',
  TIRE_QUOTE: 'TIRE_QUOTE',
  TIRE_SCAN: 'TIRE_SCAN',
};

export const INSPECTION_FOREIGN_KEY = {
  [INSPECTION_TYPE_ENUM.AUDIT]: 'originAuditId',
  [INSPECTION_TYPE_ENUM.TIRE_SCAN]: 'originTireScanId',
  [INSPECTION_TYPE_ENUM.BODY_SCAN]: 'originBodyScanId',
  [INSPECTION_TYPE_ENUM.EXTERNAL_AUDIT]: 'originWorkOrder',
  [INSPECTION_TYPE_ENUM.TIRE_QUOTE]: 'originTireQuoteId',
};

export const INSPECTION_FOREIGN_ACTION = {
  [INSPECTION_TYPE_ENUM.AUDIT]: (_, baseParams, meta) => fetchAudits(baseParams, meta),
};

export const INSPECTION_ICON = {
  [INSPECTION_TYPE_ENUM.AUDIT]: 'fb-icon--ext-audits',
  [INSPECTION_TYPE_ENUM.EXTERNAL_AUDIT]: 'fb-icon--external-audit',
  [INSPECTION_TYPE_ENUM.BODY_SCAN]: 'fb-icon--car-elevator',
  [INSPECTION_TYPE_ENUM.TIRE_SCAN]: 'fb-icon--module-tire',
  [INSPECTION_TYPE_ENUM.TIRE_QUOTE]: 'fb-icon--tire-report-question',
};

export const INSPECTION_TYPE_NAME = {
  [INSPECTION_TYPE_ENUM.AUDIT]: <FormattedMessage id="audito.audit" defaultMessage="Audit" />,
  [INSPECTION_TYPE_ENUM.EXTERNAL_AUDIT]: <FormattedMessage id="page.fiche.inspections.type.external_audit" defaultMessage="External audit" />,
  [INSPECTION_TYPE_ENUM.BODY_SCAN]: <FormattedMessage id="page.config.dealer_general.integration.titles.BODY_SCAN" defaultMessage="Body scan" />,
  [INSPECTION_TYPE_ENUM.TIRE_SCAN]: <FormattedMessage id="page.config.dealer_general.integration.titles.TIRE_SCAN" defaultMessage="Tire scan" />,
  [INSPECTION_TYPE_ENUM.TIRE_QUOTE]: <FormattedMessage id="page.config.dealer_general.integration.titles.TIRE_QUOTATION" defaultMessage="Tire quote" />,
};

export const INSPECTION_IMPORT_ACTION = {
  [INSPECTION_TYPE_ENUM.AUDIT]: openImportAudits,
  [INSPECTION_TYPE_ENUM.EXTERNAL_AUDIT]: openImportWorksModal,
  [INSPECTION_TYPE_ENUM.BODY_SCAN]: openImportBodyScans,
  [INSPECTION_TYPE_ENUM.TIRE_SCAN]: openImportTScans,
  [INSPECTION_TYPE_ENUM.TIRE_QUOTE]: openImportTireQuotes,
};

export const INSPECTION_IMPORT_ENTITY_TYPE = {
  [INSPECTION_TYPE_ENUM.AUDIT]: 'audits',
  [INSPECTION_TYPE_ENUM.EXTERNAL_AUDIT]: 'works',
  [INSPECTION_TYPE_ENUM.BODY_SCAN]: 'bodyScans',
  [INSPECTION_TYPE_ENUM.TIRE_SCAN]: 'tireScans',
  [INSPECTION_TYPE_ENUM.TIRE_QUOTE]: 'tireQuotes',
};
